import tmpl from 'blueimp-tmpl';

import {
    assertIsNonEmptyString,
    assertIsNumber,
    assertIsObject,
    assertIsTrue,
    assertObjectHasKey,
} from '../../../lib/test-and-assert/assert-base';
import { assertIsInputStatusUploader, assertIsUploaderEvent } from '../core/assert';

import { globalLogger } from '../../../qaamgo/helper/global-logger';

import { formatting } from '../../../qaamgo/helper/formatting';
import { pageNotification } from '../../../qaamgo/helper/notify';
import { isPasswordMissing } from '../../../qaamgo/helper/input-password';
import { testIsObject } from '../../../lib/test-and-assert/test-base';
import {
    INPUT_STATUS_UPLOADER_DELETED,
    INPUT_STATUS_UPLOADER_DELETING,
    INPUT_STATUS_UPLOADER_DONE,
    INPUT_STATUS_UPLOADER_FAILED,
    INPUT_STATUS_UPLOADER_LOADING,
    INPUT_STATUS_UPLOADER_PASSWORD_MISSING,
    INPUT_STATUS_UPLOADER_QUEUED,
    INPUT_STATUS_UPLOADER_SUBMITTING,
    INPUT_TYPE_DROPBOX,
    INPUT_TYPE_EXTERNAL_URL,
    INPUT_TYPE_FILE_UPLOAD,
    INPUT_TYPE_GDRIVE,
    INPUT_TYPE_INPUT_ID,
} from '../core/consts';
import {
    INPUT_EVENT_DELETED,
    INPUT_EVENT_DONE,
    INPUT_EVENT_FAIL,
    INPUT_EVENT_LOADING,
    INPUT_EVENT_PASSWORD_MISSING,
    INPUT_EVENT_QUEUED,
    INPUT_EVENT_SUBMITTING,
    INPUT_EVENT_UPLOAD_CANCELED,
    INPUT_EVENT_UPLOAD_PROGRESS,
    UPLOADER_EVENT,
} from '../core/event';
import { API_ERROR_ERROR_TRY_RELOAD, API_ERROR_LIMITS_TOO_MANY_INPUTS } from '../../api/consts';
import { eventBus } from '../../../lib/event-bus/event-bus';
import { testIsInputEvent } from '../core/test';
import { initFileUploadList } from './upload-list';

/* global tmpl */

/**
 * this takes a templates and renders it into a jquery html thing
 *
 * @param {string} templateName
 * @param {object} [options]
 *
 * @returns {*}
 */
var renderTemplate = function (templateName, options) {
    assertIsNonEmptyString(templateName, 'invalid template name');

    if (typeof options === 'undefined') {
        options = {};
    }

    assertIsObject(options);

    var templateFunction = tmpl(templateName);

    var result = templateFunction(options);

    if (result instanceof $) {
        return result;
    }

    return $('<div></div>').html(result).children();
};

var _startSpinningAnimation = function (inputId) {
    $('.input-id-' + inputId + ' i').removeClass('fa-unlock-alt');
    $('.input-id-' + inputId + ' i').addClass('fa-spin fa-spinner');
};

var _stopSpinningAnimation = function (inputId) {
    $('.input-id-' + inputId + ' i').removeClass('fa-spin fa-spinner');
    $('.input-id-' + inputId + ' i').addClass('fa-unlock-alt');
};

class UploadUi {
    /**
     * @param {Uploader} uploader
     * @param {object} config
     */
    constructor(uploader, config) {
        assertIsObject(uploader);
        assertIsObject(config);
        assertObjectHasKey(config, 'fileListSelector', 'file input selector missing');
        assertIsTrue($(config.fileListSelector).length === 1, 'could not find file input element');

        /** @type {Uploader} */
        this._uploader = uploader;

        /** @type {Api} */
        this._apiHelper = this._uploader.getApiHelper();

        /** @type {Array} */
        this.oldBitrates = [];

        /** @type string */
        this.fileListSelector = config.fileListSelector;

        /** @type boolean */
        this.showPasswordOnlyForSingleInput = config.showPasswordOnlyForSingleInput === true;

        /**
         * By default the failed inputs are always shown. They are only hidden if
         * config.showFailedInput is set to exactly 'false'
         *
         * @type {boolean}
         */
        this.showFailedInput = config.showFailedInput !== false;

        eventBus.listen(UPLOADER_EVENT, (uploaderEvent) => {
            /** @type {UploaderEvent} */
            const _uploaderEvent = uploaderEvent;

            assertIsUploaderEvent(_uploaderEvent);

            this.callback(_uploaderEvent.event, _uploaderEvent.localId, _uploaderEvent.data);
        });

        var inputs = this._uploader.getInputList();

        if (inputs.getNumberOfAllInputs() !== 0) {
            // TODO: if this happens in PROD then I need to implement that the UI reads
            //       the inputs from the uploader and displays them
            globalLogger.log('qgMultiUpload ui started with a non-empty job');
        }
    }

    /**
     *
     * @private
     */
    _getFileList() {
        var $fileList = $(this.fileListSelector);

        assertIsTrue($fileList.length === 1, 'cant find file input element');

        return $fileList;
    }

    /**
     *
     * @param {number} localId
     *
     * @private
     */
    _createNewRow(localId) {
        assertIsNumber(localId);

        var $fileList = this._getFileList();

        var $html = renderTemplate('template-base-row');

        // this saves the local id in a css class
        $html.addClass('local-id-' + localId);

        // this is used to find all input fields
        $html.addClass('uploader-input-element');

        $fileList.append($html);
    }

    /**
     *
     * @param {number} localId
     * @param {string} templateName
     * @param {object} [options]
     *
     * @private
     */
    _updateRow(localId, templateName, options) {
        assertIsNumber(localId);
        assertIsNonEmptyString(templateName);

        var $row = this._getRow(localId);

        var template = renderTemplate(templateName, options);

        $row.html(template);
    }

    /**
     *
     * @param {number} localId
     *
     * @private
     */
    _hideRow(localId) {
        assertIsNumber(localId);

        var $row = this._getRow(localId);

        $row.addClass('hidden');
    }

    /**
     *
     * @param {number} localId
     *
     * @private
     */
    _getRow(localId) {
        assertIsNumber(localId);

        var $fileList = this._getFileList();

        var row = $fileList.find('.local-id-' + localId);

        assertIsTrue(row.length === 1, 'cant find row: ' + localId);

        return row;
    }

    /**
     *
     * @param {number} localId
     * @param {string} status
     *
     * @private
     */
    _updateInputStatusCssClass(localId, status) {
        assertIsNumber(localId);
        assertIsInputStatusUploader(status);

        var $fileList = this._getFileList();

        var row = $fileList.find('.local-id-' + localId);

        assertIsTrue(row.length === 1, 'cant find row: ' + localId);

        // get all the classes
        var classList = row.attr('class').split(/\s+/);

        // search for all classes starting with 'input-status-' and remove them
        $.each(classList, function (index, className) {
            if (className.indexOf('input-status-') === 0) {
                row.removeClass(className);
            }
        });

        if (status === INPUT_STATUS_UPLOADER_QUEUED) {
            row.addClass('input-status-queued');
        } else if (status === INPUT_STATUS_UPLOADER_SUBMITTING) {
            row.addClass('input-status-submitting');
        } else if (status === INPUT_STATUS_UPLOADER_LOADING) {
            row.addClass('input-status-loading');
        } else if (status === INPUT_STATUS_UPLOADER_DONE) {
            row.addClass('input-status-done');
        } else if (status === INPUT_STATUS_UPLOADER_FAILED) {
            row.addClass('input-status-failed');
        } else if (status === INPUT_STATUS_UPLOADER_PASSWORD_MISSING) {
            row.addClass('input-status-password-missing');
        } else if (status === INPUT_STATUS_UPLOADER_DELETING) {
            row.addClass('input-status-deleting');
        } else if (status === INPUT_STATUS_UPLOADER_DELETED) {
            row.addClass('input-status-deleted');
        } else {
            row.addClass('input-status-unknown');
        }

        return row;
    }

    enablePwInput(localId) {
        var $row = this._getRow(localId);

        var pwgroup = $row.find('.password-inputs');

        var pwinput = $row.find('input[type="password"]');
        var pwbutton = $row.find('.pwbutton');

        pwinput.keydown(function (e) {
            if (e.keyCode == 13) {
                pwbutton.trigger('click', pwButtonFunction);
            }
        });

        // already visible
        if (!pwgroup.hasClass('hidden')) {
            return;
        }

        pwgroup.removeClass('hidden');

        var input = this._uploader.getInput(localId);
        var inputId = input.getInputId();

        pwbutton.addClass('input-id-' + inputId);

        var _this = this;

        var jobId = this._uploader.getJob().getId();

        var disableButton = function () {
            _startSpinningAnimation(inputId);
            // disable button while submitting password
            pwbutton.prop('disabled', true);
        };

        var enableButton = function () {
            _stopSpinningAnimation(inputId);
            // disable button while submitting password
            pwbutton.prop('disabled', false);
        };

        var pwButtonFunction = function () {
            var password = pwinput.val();

            if (password === '') {
                // TODO: show some sort of warning?
                //pgUploadUiError.showEmptyPasswordWarning();

                return;
            }

            disableButton();

            _this._apiHelper
                .setPassword(jobId, inputId, password)
                /**
                 * @param {object} data
                 * @param {InputMetadata} data.metadata
                 */
                .done(function (data) {
                    enableButton();

                    // it seems that in some cases we receive broken metadata
                    if (!testIsObject(data) || !testIsObject(data.metadata)) {
                        globalLogger.log('qgMultiUpload set password - fail - metadata broken', JSON.stringify(data));

                        pwgroup.addClass('hidden');

                        _this._uploader.getInput(localId).setStatus(INPUT_STATUS_UPLOADER_DONE);
                        _this._uploader.dispatchInputEvent(INPUT_EVENT_DONE, localId);

                        return;
                    }

                    var passwordMissing = isPasswordMissing(data.metadata);

                    // disabled because of async
                    if (passwordMissing) {
                        // TODO: write log
                        pwinput.val('');

                        pageNotification.warning('Wrong password, please enter the correct one!');

                        return;
                    }

                    pwgroup.addClass('hidden');

                    _this._uploader.getInput(localId).setStatus(INPUT_STATUS_UPLOADER_DONE);
                    _this._uploader.dispatchInputEvent(INPUT_EVENT_DONE, localId);
                })
                .fail(function (errorMessage) {
                    pwinput.val('');

                    enableButton();

                    globalLogger.log('qgMultiUpload set password fail', errorMessage + 'input id: ' + inputId);

                    pageNotification.error('Failed to set password. Please try again!');
                });
        };

        pwbutton.on('click', pwButtonFunction);

        $('.pwd').submit(function () {
            return false;
        });
    }

    enableDeleteButton(localId) {
        var $row = this._getRow(localId);

        var _this = this;

        $row.find('.deletebutton').click(function () {
            _this._uploader.deleteInput(localId);
        });
    }

    enableFileUploadCancelButton(localId) {
        var $row = this._getRow(localId);

        var _this = this;

        $row.find('.cancelbutton').click(function () {
            _this._uploader.cancelFileUpload(localId);
        });
    }

    _showPasswordEntryField(localId) {
        var status = this._uploader.getInput(localId).getStatus();

        // if it is not in password_missing state then it does not make sense to show it
        if (status !== INPUT_STATUS_UPLOADER_PASSWORD_MISSING) {
            // TODO send log
            return;
        }

        var type = this._uploader.getInput(localId).getType();
        var name = this._uploader.getInput(localId).getName();
        var size = this._uploader.getInput(localId).getSize();

        var templateName = null;

        if (type === INPUT_TYPE_DROPBOX) {
            templateName = 'template-dropbox-added';
        } else if (type === INPUT_TYPE_EXTERNAL_URL) {
            templateName = 'template-external-url-added';
        } else if (type === INPUT_TYPE_FILE_UPLOAD) {
            templateName = 'template-file-uploaded';
        } else if (type === INPUT_TYPE_GDRIVE) {
            templateName = 'template-gdrive-added';
        } else if (type === INPUT_TYPE_INPUT_ID) {
            templateName = 'template-external-url-added';
        } else {
            assertIsTrue(false);
        }

        var options = {
            name: name,
            size: formatting.fileSize(size),
        };

        this._updateRow(localId, templateName, options);
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_PASSWORD_MISSING);

        this.enableDeleteButton(localId);
        this.enablePwInput(localId);
    }

    _showUploadDone(localId) {
        var type = this._uploader.getInput(localId).getType();
        var name = this._uploader.getInput(localId).getName();
        var size = this._uploader.getInput(localId).getSize();

        var templateName = null;

        if (type === INPUT_TYPE_DROPBOX) {
            templateName = 'template-dropbox-added';
        } else if (type === INPUT_TYPE_EXTERNAL_URL) {
            templateName = 'template-external-url-added';
        } else if (type === INPUT_TYPE_FILE_UPLOAD) {
            templateName = 'template-file-uploaded';
        } else if (type === INPUT_TYPE_GDRIVE) {
            templateName = 'template-gdrive-added';
        } else if (type === INPUT_TYPE_INPUT_ID) {
            templateName = 'template-external-url-added';
        } else {
            assertIsTrue(false);
        }

        var options = {
            name: name,
            size: formatting.fileSize(size),
        };

        this._updateRow(localId, templateName, options);
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_DONE);

        this.enableDeleteButton(localId);

        var inputList = this._uploader.getInputList();
        if (inputList.getNumberOfAllInputs() > 1 && this.showPasswordOnlyForSingleInput) {
            this._hideAllPasswordMissing();
        }
    }

    _showStartLoading(localId) {
        var type = this._uploader.getInput(localId).getType();
        var name = this._uploader.getInput(localId).getName();
        var size = this._uploader.getInput(localId).getSize();

        var templateName = null;

        if (type === INPUT_TYPE_DROPBOX) {
            templateName = 'template-dropbox-adding';
        } else if (type === INPUT_TYPE_EXTERNAL_URL) {
            templateName = 'template-external-url-adding';
        } else if (type === INPUT_TYPE_FILE_UPLOAD) {
            templateName = 'template-file-uploading';
        } else if (type === INPUT_TYPE_GDRIVE) {
            templateName = 'template-gdrive-adding';
        } else if (type === INPUT_TYPE_INPUT_ID) {
            templateName = 'template-external-url-adding';
        } else {
            assertIsTrue(false);
        }

        var options = {
            name: name,
            size: formatting.fileSize(size),
        };

        this._updateRow(localId, templateName, options);
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_LOADING);

        if (type === INPUT_TYPE_FILE_UPLOAD) {
            this.enableFileUploadCancelButton(localId);
        }
    }

    _showUploadFail(localId) {
        if (this.showFailedInput === false) {
            this._hideRow(localId);
            return;
        }

        var type = this._uploader.getInput(localId).getType();
        var name = this._uploader.getInput(localId).getName();
        var size = this._uploader.getInput(localId).getSize();

        var templateName = null;

        if (type === INPUT_TYPE_DROPBOX) {
            templateName = 'template-dropbox-fail';
        } else if (type === INPUT_TYPE_EXTERNAL_URL) {
            templateName = 'template-external-url-fail';
        } else if (type === INPUT_TYPE_FILE_UPLOAD) {
            templateName = 'template-file-upload-fail';
        } else if (type === INPUT_TYPE_GDRIVE) {
            templateName = 'template-gdrive-fail';
        } else if (type === INPUT_TYPE_INPUT_ID) {
            templateName = 'template-external-url-fail';
        } else {
            assertIsTrue(false);
        }

        var options = {
            name: name,
            size: formatting.fileSize(size),
        };

        var isTooManyFilesError =
            typeof data === 'object' && data.hasOwnProperty('error') && data.error === API_ERROR_LIMITS_TOO_MANY_INPUTS;

        if (isTooManyFilesError) {
            templateName = 'template-file-upload-fail-too-many-files';
        }

        this._updateRow(localId, templateName, options);
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_FAILED);
    }

    _showUploadDeleted(localId) {
        this._hideRow(localId);
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_DELETED);

        var inputList = this._uploader.getInputList();

        if (
            inputList.getNumberOfDoneInputs() === 0 &&
            inputList.getNumberOfPasswordMissing() === 1 &&
            this.showPasswordOnlyForSingleInput
        ) {
            var _this = this;
            $(inputList._inputs).each(function (key, input) {
                if (input._status === INPUT_STATUS_UPLOADER_PASSWORD_MISSING) {
                    _this._showPasswordEntryField(input._localId);
                }
            });
        }
    }

    _showUploadCanceled(localId) {
        var name = this._uploader.getInput(localId).getName();

        var templateName = 'template-file-upload-canceled';

        var options = {
            name: name,
        };

        this._updateRow(localId, templateName, options);
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_DELETED);
    }

    _hideAllPasswordMissing() {
        $('.password-inputs').addClass('hidden');
        // TODO maybe fix the two lines below. qgAlertHelper does not exist anymore
        // qgAlertHelper.hide(qgAlertHelper.alerts.PASSWORD_MISSING);
        // qgAlertHelper.hide(qgAlertHelper.alerts.PASSWORD_WRONG);
    }

    /**
     *
     * @param {number} localId
     */
    onInputQueued(localId) {
        this._createNewRow(localId);

        this._updateRow(localId, 'template-waiting');
        this._updateInputStatusCssClass(localId, INPUT_STATUS_UPLOADER_QUEUED);
    }

    /**
     *
     * @param {number} localId
     */
    onStartLoading(localId) {
        this._showStartLoading(localId);
    }

    onUploadDone(localId) {
        this._showUploadDone(localId);
    }

    onPasswordMissing(localId) {
        var inputList = this._uploader.getInputList();

        var inputsToCount = inputList.getNumberOfDoneInputs() + inputList.getNumberOfPasswordMissing();
        if (inputsToCount > 1 && this.showPasswordOnlyForSingleInput) {
            this._showUploadDone(localId);
            return;
        }

        this._showPasswordEntryField(localId);
    }

    onUploadFail(localId, data) {
        this._showUploadFail(localId);
    }

    onUploadDeleted(localId) {
        this._showUploadDeleted(localId);
    }

    onUploadCanceled(localId) {
        this._showUploadCanceled(localId);
    }

    /**
     * This calculates the average bitrate for a certain upload by averaging over
     * the last x bitrates for this upload
     *
     * @param {number} localId
     * @param {number} currentBitrate
     * @return {number}
     * @private
     */
    getAveragedBitrate(localId, currentBitrate) {
        if (typeof this.oldBitrates[localId] === 'undefined') {
            this.oldBitrates[localId] = [];
        }

        this.oldBitrates[localId].push(currentBitrate);

        var newestData = this.oldBitrates[localId].slice(-20);

        this.oldBitrates[localId] = newestData;

        var total = 0;

        for (var i = 0; i < newestData.length; i++) {
            total += newestData[i];
        }

        return total / newestData.length;
    }

    onUploadProgress(localId, data) {
        var progressText = '';
        var progressPercentage = 0;

        if (typeof data === 'number') {
            progressText = data + '%';
            progressPercentage = data;
        } else if (typeof data === 'object') {
            var rawPercentage = (data.bytesLoaded / data.bytesTotal) * 100;
            progressPercentage = Math.floor(rawPercentage);

            var textPercentage = rawPercentage.toFixed(1) + '%';

            var bitrate = this.getAveragedBitrate(localId, data.bitrate);

            var bytesRemaining = data.bytesTotal - data.bytesLoaded;
            var secondsRemaining = (bytesRemaining * 8) / bitrate;
            var timeLeft = formatting.time(secondsRemaining);

            progressText = textPercentage + ' - ' + timeLeft;
        } else {
            throw new Error('unknown data passed in progress event');
        }
        var $row = this._getRow(localId);

        var $progressMain = $row.find('.progress');
        $progressMain.attr('aria-valuenow', progressPercentage);

        var $progressBar = $row.find('.progress-bar');
        $progressBar.css('width', progressPercentage + '%');

        var $progressText = $row.find('.progress-text');
        $progressText.text(progressText);
    }

    callback(event, localId, data) {
        try {
            if (!testIsInputEvent(event)) {
                return;
            }

            if (event === INPUT_EVENT_QUEUED) {
                this.onInputQueued(localId);

                return;
            }

            // do nothing at the moment
            if (event === INPUT_EVENT_SUBMITTING) {
                return;
            }

            if (event === INPUT_EVENT_LOADING) {
                this.onStartLoading(localId);

                return;
            }

            if (event === INPUT_EVENT_UPLOAD_CANCELED) {
                this.onUploadCanceled(localId);

                return;
            }

            if (event === INPUT_EVENT_DELETED) {
                this.onUploadDeleted(localId);

                return;
            }

            if (event === INPUT_EVENT_PASSWORD_MISSING) {
                this.onPasswordMissing(localId);

                return;
            }

            if (event === INPUT_EVENT_DONE) {
                this.onUploadDone(localId);

                return;
            }

            if (event === INPUT_EVENT_FAIL) {
                this.onUploadFail(localId, data);

                return;
            }

            if (event === INPUT_EVENT_UPLOAD_PROGRESS) {
                // 'data' is float between 0 and 1 which shows the upload progress
                this.onUploadProgress(localId, data);

                return;
            }
        } catch (e) {
            globalLogger.log('uploadui exception', e);
        }
    }
}

/**
 * Create a new sat Ui
 *
 * @param {Uploader} uploader
 * @param {Object} config
 *
 * @return {UploadUi}
 */
var createSatUi = function (uploader, config) {
    return initFileUploadList().catch(() => {
        assertIsObject(config);

        new UploadUi(uploader, config);
    });
};

export { createSatUi };

// do not use this directly! This is just exported for type-hinting/auto-completion
export { UploadUi };
